module.exports = __webpack_public_path__ + "img/cameraColor .c09ba4ed.png";